import React, { Component } from 'react';
import { getTopImage } from '../util/Helper';

class ItemForPicker extends Component {
  constructor(props) {
    super(props);
    this.state = { 
     }
  }
  
  handleSubmitClick = (e, id) => {
    e.preventDefault();
    this.props.history.push("/termekregisztracio?termek=" + id)
  }
  handleEditClick = (e, id) => {
    e.preventDefault();
    this.props.history.push("/termekszerkesztes?termek=" + id)
  }
  isAfterDeadline(){
    var yeasterday = new Date();
    yeasterday.setDate(new Date().getDate()-1);
    return new Date(this.props.item.deadline) < yeasterday;
  }

  render() { 
    //console.log("isadmin:" + this.props.isAdmin);
    //let colorClass = "kwizda-item-color-" + this.props.item.color.replace("#","");
    return ( 
      <div className="kwizda-item kwizda-item-forpicker" style={{height:'auto'}}>
          <div className={"kwizda-item-header "}>
            <div className="kwizda-item-top-container">
              {/*<h4><ItemName name={this.props.item.name} imageheight={26}></ItemName></h4>*/}
              <img alt='cimke' className="kwizda-item-top-container-image" src={"img/kwizda3_cimkek/" + getTopImage(this.props.item.id)}/>
            </div>
          </div>
          <div className="kwizda-item-desc">
            <div className="kwizda-item-problem">{this.props.item.problem_name}</div>
            <div className="kwizda-item-culturesandusage" style={{minHeight:20}}>
              <div className="kwizda-item-label">Kísérlet megvalósítás időzítése:</div>
              <div>{this.props.item.proposed_time}</div>
              <div className="kwizda-item-label">Megvalósítás helye:</div>
              <div>{this.props.item.agent}</div>
              <div className="kwizda-item-label">Helyszínek száma:</div>
              <div>{this.props.item.dose}</div>
              <div className="kwizda-item-label">Dokumentáció módja:</div>
              <div>{this.props.item.type}</div>
            </div>
            <hr/>
            
            <div style={{textAlign:'center', color:'white'}}>
              {
                this.isAfterDeadline() ? 
                <div className="kwizda-status-container2-closed" style={{width:'90%'}}>A regisztráció lezárult</div>
                :
                <div>
                  <button className="kwizda-button kwizda-item-select-button" 
                    onClick={(e)=> this.props.handleSubmitClick(e, this.props.item)}>Kiválasztom</button>
                </div>
              }
            </div>
            <div className="kwizda-item-deadline2"  >
              <div>Jelentkezési határidő: {this.props.item.deadline}</div>
            </div>
          </div>
      </div>
     );
  }
}
 
export default ItemForPicker;
